import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useGuardedNavigation } from '../../../permissions/useGuardedNavigation';

export default function PartnerActionMenu({ partner }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const { navigateDetails, navigateEdit } = useGuardedNavigation('partners');

  return (
    <>
      <IconButton onClick={(event) => setAnchorEl(event.currentTarget)}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem onClick={() => navigateDetails(partner.id)}>Details</MenuItem>
        <MenuItem onClick={() => navigateEdit(partner.id)}>Edit</MenuItem>
      </Menu>
    </>
  );
}
